export enum UserType {
  ELITE = 'elite',
  MEMBER = 'member',
  // BASIC = 'basic',
}
